import React from 'react';
import Gallery from '../components/Gallery';
import { useLanguage } from '../contexts/LanguageContext';

const GalleryPage: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <div className="pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="max-w-4xl mx-auto mb-12 text-center">
          <h1 className="text-4xl font-bold mb-4">
            {t('gallery.title')}
          </h1>
          <p className="text-xl text-gray-400">
            {t('gallery.subtitle')}
          </p>
        </div>
        
        <Gallery />
      </div>
    </div>
  );
};

export default GalleryPage;